import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['FixTour'],
});

export const fixTourApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllFixTourDownload: builder.query({
      query: (id) => `fix_tour/download?plan_job_id=${id}`,
      providesTags: ['FixTour'],
    }),
    findAllFixTourBySelection: builder.query({
      query: () => `fix_tour/plan_job_summary`,
      providesTags: ['FixTour'],
    }),
    findFixTourBySearch: builder.mutation({
      query: (params) => `fix_tour/search=${params.location_from}`,
      keepUnusedDataFor: 0,
      providesTags: ['FixTour'],
    }),
    findAllFixTourByPagination: builder.query({
      query: (payload) => {
        let url = `fix_tour/search`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['StatusSummary'],
    }),

    matchingFixTour: builder.mutation({
      query: (payload) => ({
        url: `fix_tour/matching`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['FixTour'],
    }),

    findAlternateJobcode: builder.mutation({
      query: (payload) => ({
        url: `fix_tour/find-alternative-for-failed`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['FixTour'],
    }),

    uploadFileAssignFixTour: builder.mutation({
      query: (payload) => ({
        url: `assign_fixtour/create_or_update_file/`,
        method: 'POST',
        body: payload,
      }),

      keepUnusedDataFor: 0,
      providesTags: ['FixTour'],
    }),
    deleteAllRow: builder.mutation({
      query: (id) => ({
        url: `fix_tour/clear/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['FixTour'],
    }),
    deleteById: builder.mutation({
      query: (payload) => ({
        url: `/fix_tour/plan/${payload.planId}/delete_tour/${payload.tourId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['FixTour'],
    }),
    findTripType: builder.query({
      query: () => `categories/?category_code=03`,
      providesTags: ['FixTour'],
    }),
    findLocationFromTo: builder.query({
      query: () => `create_trip/location_from_to/`,
      providesTags: ['FixTour'],
    }),

    editFixTourRow: builder.mutation({
      query: (payload) => ({
        url: `fix_tour/edit`,
        method: 'POST',
        body: payload,
      }),
      keepUnusedDataFor: 0,
      providesTags: ['FixTour'],
    }),

    checkFixTourBypass: builder.query({
      query: (payload) =>
        `fix_tour/fixtour_bypass?plan_job_id=${payload.plan_job_id}`,
      providesTags: ['FixTour'],
    }),

    confirmFixTourBypass: builder.mutation({
      query: (payload) => ({
        url: `fix_tour/fixtour_bypass`,
        method: 'POST',
        body: payload,
      }),
      keepUnusedDataFor: 0,
      providesTags: ['FixTour'],
    }),
    confirmOverDiagramBypass: builder.query({
      query: (payload) =>
        `fix_tour/over_diagram_bypass?plan_job_id=${payload.plan_job_id}`,
      providesTags: ['FixTour'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUploadFileAssignFixTourMutation,
  useMatchingFixTourMutation,
  useFindAlternateJobcodeMutation,
  useDeleteAllRowMutation,
  useFindAllFixTourBySelectionQuery,
  useFindAllFixTourByPaginationQuery,
  useDeleteByIdMutation,
  useFindTripTypeQuery,
  useFindLocationFromToQuery,
  useEditFixTourRowMutation,
} = fixTourApi;
